import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { selectAppLoading } from "../redux/slices/appSettingsSlice";
import P2PRegistrationInjection from "./P2PRegistrationInjection";

const ConnectedP2PRegistrationInjection = ({ dataLocation }) => {
    const appLoading = useSelector(selectAppLoading);

    return (
        <P2PRegistrationInjection
            appLoading={appLoading}
            dataLocation={dataLocation}
        />
    );
};

ConnectedP2PRegistrationInjection.propTypes = {
    dataLocation: PropTypes.oneOf(["header", "footer"]).isRequired,
};

export default ConnectedP2PRegistrationInjection;
